export enum TabNameKey {
	ProductDetails = 'product-details',
	VariantDetails = 'variant-details',
	MinMax = 'min-max',
}
